import React from "react"
import { Content, Wrapper } from "./TopDiscountCodesList.styled"
import { TopDiscountCodes } from "./TopDiscountCodes"
import { topDiscountData, topDiscountRulesData } from "../../views/Dashboards/DashboardSalesAggregations"
import TopDiscountCodesFilters from "./TopDiscountCodesFilters"

type Props = {
  data: topDiscountData[] | topDiscountRulesData[]
  loading: boolean
  error: object | undefined
  type: 'codes' | 'code rules' | 'external rules'
  startDate: string
  endDate: string
}

const TopDiscountCodesList = ({ data, loading, error, type, startDate, endDate }: Props) => {
  return (
    <Wrapper>
      <Content>
        <TopDiscountCodesFilters />
        <TopDiscountCodes data={data} loading={loading} error={error} type={type} startDate={startDate} endDate={endDate}></TopDiscountCodes>
      </Content>
    </Wrapper>
  )
}

export default TopDiscountCodesList
